import React from 'react';
import { PrimaryButton, Box } from '@bb-ui/react-library';

interface ArtifactPaginationProps {
  isDisabled: boolean;
  apiType: 'get' | 'search';
  getArtifacts: () => void;
  searchArtifacts: () => void;
}

export const ArtifactPagination: React.FunctionComponent<ArtifactPaginationProps> = (props) => {
  const { isDisabled, apiType, getArtifacts, searchArtifacts } = props;

  /**
   * Fetches the next set of paginated data using the provided `next_token`.
   */
  const loadMore = (): void => {
    if (apiType === 'get') getArtifacts();
    if (apiType === 'search') searchArtifacts();
  };

  return (
    <Box textAlign="center" mt={4} data-testid="artifact-pagination-loader">
      <PrimaryButton onClick={() => loadMore()} disabled={isDisabled}>
        Load more
      </PrimaryButton>
    </Box>
  );
};
